import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from './router';
import { isAuthenticated } from '../store/slices/authentication.slice';
import { useSelector } from 'react-redux';

interface ProtectedRouteProps {
  route?: RoutesList;
  children: React.ReactNode | React.ReactNode[] | undefined;
}

const ProtectedRoute = ({ route, children }: ProtectedRouteProps) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const userIsAuthenticated = useSelector(isAuthenticated);

  const checkUserToken = () => {
    console.log('isLoggedIn', isLoggedIn);

    if (!userIsAuthenticated) {
      console.log('NOT userIsAuthenticated', userIsAuthenticated);

      setIsLoggedIn(false);
      return navigate(RoutesList.Index);
    }
    setIsLoggedIn(true);
    routeConditionsGaurd();
  };

  const routeConditionsGaurd = () => {
    if (route) {
      switch (route) {
        case RoutesList.Bookings:
          return navigate(RoutesList.Bookings);
        default:
          break;
      }
    }
  };

  useEffect(() => {
    checkUserToken();
  }, [isLoggedIn]);

  return <React.Fragment>{isLoggedIn ? children : null}</React.Fragment>;
};
export default ProtectedRoute;
